import { useMemo } from 'react'
import type { EthicsFormSubmission } from './types'

const isResolved = (submission: EthicsFormSubmission) => (submission.status).toLowerCase() === 'resolved'

export function useFilteredEthicsSubmissions(submissions: EthicsFormSubmission[], activeTag: string | null, resolvedOnly = false) {
  const tags = useMemo(() => {
    const tagSet = new Set<string>()
    submissions.forEach((submission) => {
      (submission.template?.tags ?? []).forEach((tag) => tagSet.add(tag))
    })
    return Array.from(tagSet)
  }, [submissions])

  const filtered = useMemo(() => {
    const byTag = !activeTag ? submissions : submissions.filter((submission) => (submission.template?.tags ?? []).includes(activeTag))

    const base = resolvedOnly ? byTag.filter(isResolved) : byTag

    return [...base].sort((left, right) => {
      const leftResolved = isResolved(left)
      const rightResolved = isResolved(right)
      if (leftResolved === rightResolved) return 0
      return leftResolved ? -1 : 1
    })
  }, [submissions, activeTag, resolvedOnly])

  return { tags, filtered }
}
